// Shared pagination mapping helper used across modules
export function mapPaginatedResponse<T>(raw: any, normalize: (value: any) => T) {
  const unwrapObject = (candidate: any) => {
    if (!candidate || typeof candidate !== 'object' || Array.isArray(candidate)) return undefined;
    return candidate;
  };

  const primaryContainer = unwrapObject(raw?.data) ?? unwrapObject(raw) ?? raw;
  const secondaryContainer = unwrapObject(primaryContainer?.data);

  const candidateArrays = [
    primaryContainer?.items,
    secondaryContainer?.items,
    primaryContainer?.data,
    secondaryContainer?.data,
    raw?.items,
    raw?.data,
    Array.isArray(primaryContainer) ? primaryContainer : undefined,
    Array.isArray(raw) ? raw : undefined,
  ];

  const itemsSource = candidateArrays.find((value): value is any[] => Array.isArray(value)) ?? [];
  const items = itemsSource.map((item) => normalize(item));

  const pagination =
    primaryContainer?.pagination ??
    secondaryContainer?.pagination ??
    raw?.pagination ??
    raw?.meta?.pagination ??
    primaryContainer?.meta?.pagination ??
    secondaryContainer?.meta?.pagination;

  const summary = primaryContainer?.summary ?? secondaryContainer?.summary ?? raw?.summary;

  const appliedFilters =
    primaryContainer?.appliedFilters ??
    primaryContainer?.applied_filters ??
    secondaryContainer?.appliedFilters ??
    secondaryContainer?.applied_filters ??
    raw?.appliedFilters ??
    raw?.applied_filters;

  return {
    items,
    pagination,
    summary,
    appliedFilters,
  };
}
